import { usePin } from 'hooks/usePin';
import { useSelection } from 'hooks/useSelection';
import type { AnyObject } from 'types/AnyObject';

import { useCallback } from 'react';

import { onTableSettingsConfirm } from './helpers';

export interface IUseTableHideAndPinSettings {
    tableID: string;
}

export const useTableHideAndPinSettings = ({ tableID }: IUseTableHideAndPinSettings) => {
    const [selection, , , setSelection] = useSelection(tableID);
    const [pinnedItems, , , setPinned] = usePin(tableID);

    const isColumnVisible = useCallback((id: string) => selection[id] ?? true, [selection]);

    const tableSettingsConfirmHandleCreator = useCallback(
        (settingsColumns: AnyObject[]) => (visible: { pinnedColumNames: string[] } | { [key: string]: string }) => {
            onTableSettingsConfirm({
                setSelection,
                setPinned,
                settingColumns: settingsColumns,
                incomingColumns: visible,
            });
        },
        [setSelection, setPinned],
    );

    return {
        isColumnVisible,
        tableSettingsConfirmHandleCreator,
        pinnedItems,
    };
};
